export default __webpack_public_path__ + "static/RoadmapFinal-776dcd7959cb2a2b16bfa1a09ecb802d.png";